export const areSelectionsEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false;
  const ids1 = arr1.map(e => e.entity_name).sort();
  const ids2 = arr2.map(e => e.entity_name).sort();
  return ids1.every((id, idx) => id === ids2[idx]);
};
